__turbopack_context__.v({
  "dropzone": "UploadDropzone-module-scss-module__s9AZCq__dropzone",
  "dropzoneActive": "UploadDropzone-module-scss-module__s9AZCq__dropzoneActive",
  "dropzoneDisabled": "UploadDropzone-module-scss-module__s9AZCq__dropzoneDisabled",
  "dropzoneEmpty": "UploadDropzone-module-scss-module__s9AZCq__dropzoneEmpty",
  "dropzoneWithImage": "UploadDropzone-module-scss-module__s9AZCq__dropzoneWithImage",
  "emptyContent": "UploadDropzone-module-scss-module__s9AZCq__emptyContent",
  "enter": "UploadDropzone-module-scss-module__s9AZCq__enter",
  "exit": "UploadDropzone-module-scss-module__s9AZCq__exit",
  "fade-in": "UploadDropzone-module-scss-module__s9AZCq__fade-in",
  "fade-out": "UploadDropzone-module-scss-module__s9AZCq__fade-out",
  "fade-out-80": "UploadDropzone-module-scss-module__s9AZCq__fade-out-80",
  "fileInput": "UploadDropzone-module-scss-module__s9AZCq__fileInput",
  "previewImage": "UploadDropzone-module-scss-module__s9AZCq__previewImage",
  "previewWrap": "UploadDropzone-module-scss-module__s9AZCq__previewWrap",
  "primaryText": "UploadDropzone-module-scss-module__s9AZCq__primaryText",
  "secondaryText": "UploadDropzone-module-scss-module__s9AZCq__secondaryText",
  "slide-in-from-bottom": "UploadDropzone-module-scss-module__s9AZCq__slide-in-from-bottom",
  "slide-in-from-left": "UploadDropzone-module-scss-module__s9AZCq__slide-in-from-left",
  "slide-in-from-right": "UploadDropzone-module-scss-module__s9AZCq__slide-in-from-right",
  "slide-in-from-top": "UploadDropzone-module-scss-module__s9AZCq__slide-in-from-top",
  "slide-out-to-bottom": "UploadDropzone-module-scss-module__s9AZCq__slide-out-to-bottom",
  "slide-out-to-left": "UploadDropzone-module-scss-module__s9AZCq__slide-out-to-left",
  "slide-out-to-right": "UploadDropzone-module-scss-module__s9AZCq__slide-out-to-right",
  "slide-out-to-top": "UploadDropzone-module-scss-module__s9AZCq__slide-out-to-top",
  "uploadIcon": "UploadDropzone-module-scss-module__s9AZCq__uploadIcon",
  "uploadingOverlay": "UploadDropzone-module-scss-module__s9AZCq__uploadingOverlay",
  "zoom-in": "UploadDropzone-module-scss-module__s9AZCq__zoom-in",
  "zoom-out": "UploadDropzone-module-scss-module__s9AZCq__zoom-out",
});
